export const checkPositiveNumber = (value: any) => {
  return (!value && value !== 0) || value < 0;
};
